module.exports = __webpack_public_path__ + "static/media/16.6607b9c2.jpg";